/* eslint-disable eslint-comments/disable-enable-pair -- needed */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { IntlProvider, FormattedMessage } from 'react-intl';
import { Link as DLSLink, Heading, Layout } from '@americanexpress/dls-react';
import { renderHTML } from '../../../../utilities/render-html';

export function CardBanner(props) {
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(min-width: 320px)');
    const handleResize = () => setIsMobileView(mediaQuery.matches);

    // Set initial value
    handleResize();

    // Add listener
    mediaQuery.addEventListener('change', handleResize);

    // Cleanup listener on unmount
    return () => mediaQuery.removeEventListener('change', handleResize);
  }, []);

  const languageData = props?.languageData;
  return (
    <Layout className="margin-1-tb" innerContainerClassName="pad-3-lg-up pad-2">
      <div className="flex flex-column-sm-down">
        {
          isMobileView && (
            <div className="margin-auto-lr-sm-down margin-2-r-md-up margin-2-b-sm-down">
              <img
                src={props?.cardImageURL}
                alt={props?.properCardName}
                title={props?.properCardName}
              />
            </div>
          )
        }

        <IntlProvider locale={props?.locale} messages={languageData} defaultLocale="en-US">
          <div>
            {
              isMobileView && (
                <Heading level={1} variant="sans-medium-regular" className="pad-2-b">
                  <FormattedMessage id="view-all.card-banner.explore-benefits" defaultMessage="Explore Benefits" />
                </Heading>
              )
            }
            <Heading level={2} variant="sans-small-regular" style={{ maxWidth: 600 }}>
              {renderHTML(props?.heroDesc)}
            </Heading>
            <DLSLink
              className="pad-2-t"
              id="loginLink"
              href={props?.loginUrl}
              data-testid="login-link"
            >
              <FormattedMessage id="view-all.card-banner.cta-link" defaultMessage="Log in" />
            </DLSLink>
          </div>
        </IntlProvider>
      </div>
    </Layout>

  );
}

CardBanner.propTypes = {
  /**
   URL for card banner image
   */
  cardImageURL: PropTypes.string.isRequired,
  /**
   Card banner image alt text
   */
  properCardName: PropTypes.string.isRequired,
  /**
   Hero text
   */
  heroDesc: PropTypes.string.isRequired,
  /**
   URL destination for log-in button
   */
  loginUrl: PropTypes.string.isRequired,
};
